import React, { FC } from 'react';
import { BaseIcon } from '../BaseIcon';

export const DocumentRealEstate: FC = () => <BaseIcon code={'document-real-estate'} />;
